/* eslint-disable @typescript-eslint/no-magic-numbers */
export function generateRandomId(): string {
    return Math.random().toString(36).substr(2, 9);
}